<div class="modal-header justify-content-between">
  <h4 class="modal-title header-13">Set Up Connection</h4>
  <div>
    <button
      type="button"
      class="accello-icon-btn"
      (mousedown)="isActive = true"
      (mouseup)="isActive = false"
      (mouseleave)="isActive = false"
      (click)="activeModal.dismiss('Cross click')"
    >
      <img
        [src]="
          isActive
            ? 'assets/images/virtusa-icons/close-dark.svg'
            : 'assets/images/virtusa-icons/close.svg'
        "
      />
    </button>
  </div>
</div>

<div class="assets-detail">
  <!-- Warning Message -->
  <div *ngIf="!isTCGEnabled" class="warning-alert d-flex align-items-center mb-3 p-3 rounded" role="alert">
    <img 
      src="assets/images/virtusa-icons/warning.svg" 
      alt="Warning" 
      width="20" 
      height="20" 
      class="me-2"
    />
    <span>{{ warningMessage }}</span>
  </div>

  <div class="cont-group rounded v-center p-3" [ngClass]="{ active: 'true' }">
    <div class="d-flex justify-content-between align-items-center mb-3">
      <label class="v-center" for="global">
        Configure application context separately for each asset
      </label>
    </div>

    <div class="d-flex align-items-center">
      <label class="v-center ml-35 w-35" for="global">
        Test Case Generator
      </label>
      <nz-select
        [(ngModel)]="fileConnection"
        nzPlaceHolder="Select connection"
        nzShowSearch
        [disabled]="isProcessing || !isTCGEnabled || isLoadingExistingContext"
        class="flex-grow-1"
      >
        <nz-option-group
          *ngFor="let group of groupedFileConnections"
          [nzLabel]="group.label"
        >
          <nz-option
            *ngFor="let option of group.options"
            [nzValue]="option.value"
            [nzLabel]="option.label"
          ></nz-option>
        </nz-option-group>
      </nz-select>
      <div *ngIf="isLoadingExistingContext" class="spinner-border spinner-border-sm ms-2" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
  </div>

  <!-- Progress Bar -->
  <div *ngIf="isProcessing" class="cont-group rounded p-3 mt-3">
    <div class="mb-2">
      <span class="accello-general-text6">{{ progressMessage }}</span>
    </div>
    <mat-progress-bar
      mode="determinate"
      [value]="progressValue"
      color="primary"
    ></mat-progress-bar>
    <div class="mt-1 text-end">
      <small class="accello-general-text7">{{ progressValue }}%</small>
    </div>
  </div>
</div>

<div class="modal-footer border-0">
  <div class="d-flex justify-content-end">
    <button
      class="btn-accello-secondary mx-2 open-btn"
      (click)="activeModal.dismiss('Cross click')"
      [disabled]="isProcessing"
    >
      Cancel
    </button>
    <button
      class="btn-accello-primary-light open-btn"
      (click)="save()"
      [disabled]="isProcessing || !fileConnection || isSameFile"
    >
      {{ isProcessing ? "Processing..." : "Save" }}
    </button>
  </div>
</div>
